import type { Selection } from '@iconik-io/uad';

export function selectionToSet(
  selectedKeys: Selection | undefined,
): Set<string> {
  if (!selectedKeys || selectedKeys === 'all') {
    return new Set<string>();
  }

  const selectedIds = new Set<string>();
  for (const selectedKey of selectedKeys) {
    if (typeof selectedKey === 'string') {
      selectedIds.add(selectedKey);
    }
  }

  return selectedIds;
}
